import React,{useState} from "react";
import { Switch, Typography } from "antd";
import { isEmpty } from "lodash";
import ModalContainer from "../../ModalContainer";
import ModalInputField from "../../ModalInputField"; 
import PlacesLocation from "../../PlacesLocation";
import "../../../css/components.css"
import { useUpdateProfileJobCriteriaPatchMutation, useUpdateProfileMutation, useUpdateUserMutation } from "../../../store/appSlice";
import { useAppSelector } from "../../../store/store";
import HeaderModalText from "../../HeaderModalText";
const jobs=[
"Full time",


 "Part time",
    
  
   "Short-term",
    
"Project/Freelance"
  

] 

function AboutMeModal({data,isVisible,onClose,getUpdatedData}) {

  const { user ,profileData} = useAppSelector((state) => state["user"]);
// console.log({profileData})
    const [input, setInput] = useState({
        fullName: profileData?.candidate?.user?.name??'',
        title:  profileData?.candidate?.title??"",

      }); 



  const[livingLocationLatLng,setLivingLocationLatLng]=useState({lat:profileData?.candidate?.location?.lat??"",lng:profileData?.candidate?.location?.lng??""})
    
  const[lookingForJobLatLng,setLookingForJobLatLng]=useState({lat:profileData?.candidate?.candidateJobCriteria?.location?.lat??"",lng:profileData?.candidate?.candidateJobCriteria?.location?.lng??""})
  
    const[livingLocationAddress,setLivingLocationAddress]=useState(`${profileData?.candidate?.city??''} ${profileData?.candidate?.country??''}`)

  const[lookingForJobAddress,setLookingForJobAddress]=useState(`${profileData?.candidate?.candidateJobCriteria?.city??''} ${profileData?.candidate?.candidateJobCriteria?.country??''}`)

  const[selectedJobTypes,setSelectedJobTypes]=useState(profileData?.candidate?.candidateJobCriteria?.jobType??[])

  const[isRemote,setRemoteChange]=useState(profileData?.candidate?.candidateJobCriteria?.isRemote??false)


  const [updateProfile] = useUpdateProfileMutation();

  const [updateUser] = useUpdateUserMutation();

  const [updateProfileJobCriteriaPatch] = useUpdateProfileJobCriteriaPatchMutation()




    const[error,setError]=useState({
      fullName:"",
      title:"",
      selectedJobTypes:'',
      livingLocation:'',
      lookingForJobLocation:''
    })  


   

const onChangeText = (event) => {
    // console.log({event:event}) 
    setInput({
      ...input,
      [event.target.name]: event.target.value,
    });
  };


const getLivingLatLngAndAddress=(latlng,address)=>{
  setLivingLocationLatLng(latlng);
  setLivingLocationAddress(address);
}

const onLivingLocationTextChange=(e)=>{
  setLivingLocationAddress(e.target.value)
}



const getLookingForJobLatLngAndAddress=(latlng,address)=>{
  setLookingForJobLatLng(latlng);
  setLookingForJobAddress(address);
}

const onLookingForJobLocationTextChange=(e)=>{
  setLookingForJobAddress(e.target.value);
}

const validation=()=>{

  const{ fullName,
  title, 
}=input
  
  let valid = true;
  let fullNameError = "";
  let titleError = "";
  let selectedJobTypesError=""
  
  
  if (isEmpty(fullName)) {
    valid = false;
    fullNameError = "Name cannot be empty";
  }
  
  if (isEmpty(title)) {
    valid = false;
    titleError = "Title cannot be empty";
  } 
 
  if(isEmpty(selectedJobTypes)){
    valid = false;
    selectedJobTypesError = "You need to select atleast 1 job type";
  }
  
  
  setError({
    ...error,
    fullName:fullNameError,
    title:titleError,
    selectedJobTypes:selectedJobTypesError

  });
  
  return valid;
  };


const onSubmit=()=>{

  if(validation()){
  let payload={}

payload={
  param:user?.userId,
  name:input.fullName
}

updateUser(payload) 
.unwrap()
.then((incomingData) => {
  // console.log({InsideUserUpdate:incomingData})

  payload={
    param:user?.id,
    isRemote,
    jobType:selectedJobTypes,
    location:lookingForJobLatLng
  }

  
  updateProfileJobCriteriaPatch(payload)
.unwrap()
.then((incomingData) => {
  // console.log({InsideupdateProfileJobCriteria:incomingData})

  payload={
    param:user?.id,
    title:input.title,
    location:livingLocationLatLng, 
  }

  updateProfile(payload)
  .unwrap()
  .then((incomingData) => {
    // console.log({insideUpdate:incomingData})
    getUpdatedData()
    onClose()

  })

})

})

  }

}



const onSelectJobType = (incomingItem) => {
  let tempJobTypes = [...selectedJobTypes];
  if (selectedJobTypes.includes(incomingItem)) {
    const newArray = tempJobTypes.filter(function (item) {
      return item != incomingItem;
    });
    setSelectedJobTypes(newArray);
  } else {
    const newArray = [...tempJobTypes, incomingItem];
    // console.log({newArray})
    setSelectedJobTypes(newArray);
  }
};




const errorSec = (err) => (
  <div style={{ marginBottom: "20px" }}>
    <text style={{ color: "red" }}>{err}</text>
  </div>
);



  return (
<ModalContainer onClose={onClose} isVisible={isVisible}
onBtnClick={onSubmit}
modalHeaderText={"Profile"}
modalSubHeaderText={"Your preferences"}
>

<div style={{marginBottom:'2rem'}}>   
<ModalInputField name={'fullName'} headerText={'Full Name'} onChangeText={onChangeText} inputFieldValue={input.fullName} hasError={!isEmpty(error.fullName)}/>
{!isEmpty(error.fullName) && errorSec(error.fullName)}

</div>
 

    <div style={{marginBottom:'2rem'}}>   
<ModalInputField name={'title'} headerText={'Title'} onChangeText={onChangeText} inputFieldValue={input.title} hasError={!isEmpty(error.title)} />
{!isEmpty(error.title) && errorSec(error.title)}

</div>   
 


 <div  >
 <div style={{marginBottom:'3rem'}}>
 <HeaderModalText text={"Location you are living in"}/>
 </div> 

  <PlacesLocation 
     
     getLocationLatLngAndAddress={getLivingLatLngAndAddress}
     locationAddress={livingLocationAddress}
     onLocationTextChange={onLivingLocationTextChange}
     hasError={!isEmpty(error.livingLocation)}
     setLatLng={setLivingLocationLatLng}
  />
  </div> 

    <div style={{marginBottom:'7rem'}}>

   <div style={{marginBottom:'3rem',marginTop:'60px'}}> 

 <HeaderModalText text={"Location you are looking for the job"}/>
 </div> 

  <PlacesLocation
getLocationLatLngAndAddress={getLookingForJobLatLngAndAddress}
locationAddress={lookingForJobAddress}
onLocationTextChange={onLookingForJobLocationTextChange}
hasError={!isEmpty(error.lookingForJobLocation)}
setLatLng={setLookingForJobLatLng}
  />
  </div>   


    <div style={{flexDirection:'row',display:'flex',flexWrap:'wrap',marginTop:'3rem',marginBottom:'2rem'}}>
{jobs.map((item)=>{
  const isSelected=selectedJobTypes.includes(item)
  return (
    <div 
    className={`jobTypeTiles ${isSelected?"background_black":"background_white"}`}
    onClick={()=>onSelectJobType(item)}
    >
   {/* <text className={`${isSelected?"color_black":"color_white"}`} style={{fontWeight:'500',fontSize:'14px'}}>{item.name}</text> */}
   <text className={`${isSelected?"color_white":"color_black"}`} style={{fontWeight:'500',fontSize:'14px'}}>{item}</text>

</div>
  ) 
})}
    </div>
    {!isEmpty(error.selectedJobTypes) && errorSec(error.selectedJobTypes)}




    <div style={{flexDirection:"row",display:'flex',flex:1,alignItems:'center',justifyContent:'space-between'}}>
<Typography style={{fontSize:'2rem',fontWeight:"600"}}>I'm open to remote work</Typography>
<div style={{marginTop:'4px'}}>   

<Switch onChange={()=>setRemoteChange(!isRemote)} checked={isRemote}/>
    </div>
    </div>




</ModalContainer>
  );
}

export default AboutMeModal;
